import dateToString from '../../../function/dateToString';
import { defaultPerPageValue } from '../../../constants/PaginationPerPageConstants';
import { sortValues } from '../../../constants/NavrhAktEuSortConstants';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: NavrhAktuEuFilter,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter.hladanyVyraz) {
    updatedSearchParams.set('hladanyVyraz', filter.hladanyVyraz);
  }

  if (filter.cisloLegislativnehoMaterialu) {
    updatedSearchParams.set('cisloLegislativnehoMaterialu', filter.cisloLegislativnehoMaterialu);
  }

  if (filter.identifikatorAktu) {
    updatedSearchParams.set('identifikatorAktu', filter.identifikatorAktu);
  }

  if (filter.nazovLegislativnehoMaterialu) {
    updatedSearchParams.set('nazovLegislativnehoMaterialu', filter.nazovLegislativnehoMaterialu);
  }

  if (filter.nazovAktu) {
    updatedSearchParams.set('nazovAktu', filter.nazovAktu);
  }

  if (filter?.institucia?.kod) {
    updatedSearchParams.set('institucia', filter.institucia.kod);
  }

  if (filter?.type?.kod) {
    updatedSearchParams.set('typAktu', filter.type.kod);
  }

  if (filter.medziinstitucionalnyKod) {
    updatedSearchParams.set('medziinstitucionalnyKod', filter.medziinstitucionalnyKod);
  }

  if (filter.datumPrijatiaAktuOd) {
    updatedSearchParams.set('datumPrijatiaAktuOd', dateToString(filter.datumPrijatiaAktuOd));
  }

  if (filter.datumPrijatiaAktuDo) {
    updatedSearchParams.set('datumPrijatiaAktuDo', dateToString(filter.datumPrijatiaAktuDo));
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if (!sortValues.includes(sort[0])
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
